export class ActivateGcpFolderResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gcpFolder",
            "baseName": "gcpFolder",
            "type": "GcpOrganization",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ActivateGcpFolderResponse.attributeTypeMap;
    }
    constructor() {
    }
}
